import type { ToRecipient } from './ToContactPicker';
import type { ContactLike } from '@/lib/email/oneoff-merge';

// Decide the recipient after the contactId preselect fetch resolves.
// Applies the matched contact UNLESS the user has already manually changed the
// recipient (userTouched) — so it upgrades the auto-seeded raw email to the
// contact, but never clobbers a deliberate user edit.
export function resolvePreselectedRecipient(
  prev: ToRecipient,
  contact: ContactLike,
  userTouched: boolean,
): ToRecipient {
  if (userTouched) return prev;
  return { kind: 'contact', contact };
}
